export function schema_referentiel() {
	return {
		title: "Paramètres",
		type: "array",
		items: {
			title: "Niveau",
			type: "object",
			properties: {
				conditions: {
					title: "Conditions",
					type: "array",
					format: "table",
					items: {
						type: "string",
						title: "Colonnes",
					},
				},
				actions: {
					title: "Actions",
					type: "array",
					format: "table",
					items: {
						type: "string",
						title: "Colonnes",
					},
				},
			},
		},
	};
}
